import { getPriceBodyMatch } from './getPriceBodyMatch';

export function getReccomendationsForMLPOnly(
  rankedBodyTypes,
  rankedPriceRanges,
  numberOfReccomendationsNeeded,
) {
  const finalReccomendations = [];

  const reccomendations = getPriceBodyMatch(
    numberOfReccomendationsNeeded,
    rankedPriceRanges,
    rankedBodyTypes,
    [],
  );

  finalReccomendations.push(...reccomendations);

  return finalReccomendations;
}
